import { render, staticRenderFns } from "./HomeConversation.vue?vue&type=template&id=384e29ac&scoped=true&"
import script from "./HomeConversation.vue?vue&type=script&lang=js&"
export * from "./HomeConversation.vue?vue&type=script&lang=js&"
import style0 from "./HomeConversation.vue?vue&type=style&index=0&id=384e29ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e29ac",
  null
  
)

export default component.exports